import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import en from "./locales/en.json"
import ms from "./locales/ms.json"

// Customer-portal i18n. UI text only (English + Bahasa Melayu); backend content
// (product/prize/category names, transaction reasons) is left as stored.
// Resources are bundled synchronously, so no Suspense is needed for loading.
// The chosen language persists in localStorage (key `i18nextLng`) via the detector.
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ms: { translation: ms },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "ms"],
        load: "languageOnly", // map en-US -> en, ms-MY -> ms
        interpolation: { escapeValue: false }, // React already escapes
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        react: { useSuspense: false },
    })

// Keep <html lang> in sync with the active language.
const syncHtmlLang = (lng) => {
    if (typeof document !== "undefined") document.documentElement.lang = lng || "en"
}
syncHtmlLang(i18n.language)
i18n.on("languageChanged", syncHtmlLang)

export default i18n
